import { render, staticRenderFns } from "./InspectionsTable.vue?vue&type=template&id=4a5d828e&scoped=true"
import script from "./InspectionsTable.vue?vue&type=script&lang=ts"
export * from "./InspectionsTable.vue?vue&type=script&lang=ts"
import style0 from "./InspectionsTable.vue?vue&type=style&index=0&id=4a5d828e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d828e",
  null
  
)

export default component.exports